// HeartPopup.jsx
import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./HeartPopup.css";
import heart from "../imagesHome/heart.png";

const HeartPopup = ({ livesCount }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [animateLoss, setAnimateLoss] = useState(false);
  const previousLivesCount = useRef(livesCount);
  const visibleLives = Math.min(3, Math.max(0, Number(livesCount) || 0));

  const openPopup = () => {
    if (isVisible && isOpen) return;
    setIsVisible(true);
    requestAnimationFrame(() => setIsOpen(true));
  };

  const closePopup = () => {
    if (!isVisible) return;
    setIsOpen(false);
  };

  useEffect(() => {
    if (livesCount < previousLivesCount.current) {
      setAnimateLoss(true);
      const timer = setTimeout(() => setAnimateLoss(false), 500);
      previousLivesCount.current = livesCount;
      return () => clearTimeout(timer);
    }

    previousLivesCount.current = livesCount;
  }, [livesCount]);

  useEffect(() => {
    if (!isVisible) return;

    const closeTimer = setTimeout(() => {
      if (!isOpen) {
        setIsVisible(false);
      }
    }, 280);

    return () => clearTimeout(closeTimer);
  }, [isVisible, isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("quiz-active");
      document.documentElement.classList.add("quiz-active");
    } else {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    }

    return () => {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isVisible) return;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isVisible]);

return (
  <div className="heart-popup-container">
    <button
      type="button"
      className={`oriented-heart-track ${
        animateLoss ? "hearts-loss-animation" : ""
      }`}
      onClick={isOpen ? closePopup : openPopup}
      aria-label={`Ai ${visibleLives} vieti. Deschide detaliile vietilor.`}
    >
     <span className="header-hearts-list" aria-hidden="true">
  {[0, 1, 2].map((index) => (
    <img
      key={`header-heart-${index}`}
      src={heart}
      className={[
        'header-heart-icon',
        index < visibleLives
          ? 'header-heart-active'
          : 'header-heart-consumed',
      ]
        .filter(Boolean)
        .join(' ')}
      draggable={false}
      alt=""
    />
  ))}
</span>
    </button>

    {isVisible &&
      createPortal(
        <>
          <div
            className={`popup-question-overlay ${isOpen ? "open" : ""}`}
            onClick={closePopup}
          />

          <div
            className={`popup-question ${isOpen ? "open" : ""}`}
            role="dialog"
            aria-modal="true"
            aria-label="Detalii vieti"
          >
            <button
              type="button"
              className="popup-question-close"
              onClick={closePopup}
            >
              x
            </button>

            <div className="popup-question-content">
              <div className="popup-question-coins-info heart-popup-coins-info">
                <img
                  src={heart}
                  className="heart-popup-bigicon"
                  draggable={false}
                  alt="Vieti"
                />

                <span>Vieti</span>
              </div>

              <div className="heart-popup-summary">
                <div className="heart-popup-title-row">
                  <h3>Ai {livesCount} vieti</h3>
                </div>

                <div
                  className="heart-popup-lives-row heart-popup-lives-row--summary"
                  aria-label={`Ai ${livesCount} vieti din 3`}
                >
                  {[0, 1, 2].map((index) => (
                    <img
                      key={index}
                      src={heart}
                      className={`heart-popup-info-icon ${
                        index < visibleLives
                          ? "heart-slot-filled"
                          : "heart-slot-empty"
                      }`}
                      draggable={false}
                      alt={
                        index < visibleLives
                          ? "Viata activa"
                          : "Viata pierduta"
                      }
                    />
                  ))}
                </div>

                <p>
                  Foloseste-le pentru a continua chiar si daca mai faci greseli.
                </p>

                <button
                  type="button"
                  className="heart-popup-btn"
                  onClick={closePopup}
                >
                  Am inteles
                </button>
              </div>
            </div>
          </div>
        </>,
        document.body
      )}
  </div>
);

};

export default HeartPopup;
